import { publicClient, privateClient } from './client';
import { Token } from './Token';

const transactionsToken = (pub: boolean) => new Token(pub ? publicClient : privateClient);
export default transactionsToken;
